import {
  Box,
  Paper,
  Typography,
  Stack,
  useTheme,
} from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";


const COST_SPLIT = [
  { label: "Development", value: 55 },
  { label: "UI / UX Design", value: 18 },
  { label: "Features", value: 17 },
  { label: "Testing", value: 10 },
];

const CostDistributionPremium = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2.5, md: 3.5 },
        borderRadius: 2,
        background:
          "linear-gradient(180deg, #FFFFFF 0%, rgba(246,247,235,0.9) 100%)",
        border: "1px solid var(--color-midnight-15)",
      }}
    >
      <Typography
        sx={{
          fontWeight: 800,
          fontSize: "1.05rem",
          mb: 2.5,
        }}
      >
        Cost Distribution
      </Typography>

      <Stack spacing={2.2}>
        {COST_SPLIT.map((item) => (
          <Box key={item.label}>
            {/* Label Row */}
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              mb={0.6}
            >
              <Typography fontSize="0.9rem" fontWeight={600}>
                {item.label}
              </Typography>

              <Box
                sx={{
                  px: 1.2,
                  py: 0.3,
                  fontSize: "0.75rem",
                  fontWeight: 700,
                  borderRadius: 999,
                  backgroundColor: "rgba(233,79,55,0.12)",
                  color: "var(--color-fiery)",
                }}
              >
                {item.value}%
              </Box>
            </Stack>

            {/* Track */}
            <Box
              sx={{
                height: 12,
                borderRadius: 999,
                backgroundColor: "rgba(15,58,66,0.08)",
                overflow: "hidden",
              }}
            >
              {/* Fill */}
              <Box
                sx={{
                  height: "100%",
                  width: `${item.value}%`,
                  borderRadius: 999,
                  background: "linear-gradient(90deg, #E94F37, #FF7A5A)",
                  boxShadow: "0 4px 10px rgba(233,79,55,0.35)",
                  transition: "width 0.6s ease",
                }}
              />
            </Box>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
};

export default CostDistributionPremium;
